import { IconSave } from '@maia/icons';
import { CustomerDto } from '@maia/shared';
import { Button, getErrors } from '@maia/ui';
import * as v from 'valibot';
import { useAppForm } from '../form/dynamic-form/dynamic-form';
import { personalDataFormSchema } from './personal-data-form.schema';
import { FormEvent } from 'react';

type PersonalData = {
  initials: CustomerDto['consumer']['initials'];
  firstname: CustomerDto['consumer']['firstName'];
  lastname: CustomerDto['consumer']['lastName'];
}

type EditPersonalDataFormValues = {
  customerGuid: string;
  body: PersonalData;
};

type EditPersonalDataFormProps = {
  customer: CustomerDto;
  onSubmit: (value: EditPersonalDataFormValues) => void;
  isPending: boolean;
};

export function EditPersonalDataForm(props: EditPersonalDataFormProps) {
  const { customer, onSubmit, isPending } = props;

  const form = useAppForm({
    defaultValues: {
      initials: customer.consumer.initials,
      firstname: customer.consumer.firstName,
      lastname: customer.consumer.lastName,
      statement: false,
    },
    validators: {
      onChange: personalDataFormSchema
    },
    onSubmit: ({ value }) =>
      onSubmit({
        customerGuid: customer.guid,
        body: value,
      }),
  });

  function handleFormSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    event.stopPropagation();
    form.handleSubmit();
  }

  return (
    <form
      className="grid grid-cols-12 gap-24 col-span-full"
      onSubmit={handleFormSubmit}
    >
      <form.AppField name="initials">
        {(field) => {
          return (
            <field.TextField
              label="Voorletters"
              className="col-span-2"
              inputOverrides={{
                fieldSize: 'large',
                placeholder: 'Voorletters',
              }}
              error={getErrors(field)}
            />
          );
        }}
      </form.AppField>
      <form.AppField name="firstname">
        {(field) => {
          return (
            <field.TextField
              label="Voornaam"
              className="col-span-5"
              inputOverrides={{
                fieldSize: 'large',
                placeholder: 'Voornaam',
              }}
              error={getErrors(field)}
            />
          );
        }}
      </form.AppField>

      <form.AppField name="lastname">
        {(field) => {
          return (
            <field.TextField
              label="Achternaam"
              className="col-span-5"
              inputOverrides={{
                fieldSize: 'large',
                placeholder: 'Achternaam',
              }}
              error={getErrors(field)}
            />
          );
        }}
      </form.AppField>

      <form.AppField name="statement">
        {(field) => (
          <field.StatementCheckboxField
            className="col-span-full"
            label="Ik bevestig dat de klant begrijpt dat deze wijziging van invloed kan zijn op de verzekeringspremie en dat de verzekering opnieuw wordt beoordeeld. Ik verklaar dat de wijziging uitsluitend betrekking heeft op een correctie van de naam en dat er geen sprake is van een persoonswijziging."
          />
        )}
      </form.AppField>
      <div className="col-span-full flex justify-end">
        <form.Subscribe
          selector={(state) => {
            return [
              state.canSubmit,
              state.isSubmitting,
              state.isValid,
              state.values,
            ];
          }}
        >
          {([canSubmit, isSubmitting, isValid, values]) => (
            <Button
              type="submit"
              intent="cta"
              iconLeft={IconSave}
              isDisabled={
                !canSubmit ||
                isSubmitting ||
                isPending ||
                !isValid ||
                !values.statement
              }
              isLoading={isPending}
            >
              Wijziging aanvragen
            </Button>
          )}
        </form.Subscribe>
      </div>
    </form>
  );
}
